import { useQuery } from '@tanstack/react-query';

import { getBanners } from '../queries/banner';
import { useBuyerHomeQueryGate } from './useBuyerHomeQueryGate';

export const useGetBanners = () => {
  const { canQuery, queryToken, selectedShipToId } = useBuyerHomeQueryGate();
  return useQuery({
    queryKey: ['Banners', selectedShipToId],
    queryFn: () => getBanners(queryToken, selectedShipToId),
    enabled: canQuery,
  });
};
